import { render } from "./SimpleSectionHeaderLocs.vue?vue&type=template&id=74712ac6"
import script from "./SimpleSectionHeaderLocs.vue?vue&type=script&lang=js"
export * from "./SimpleSectionHeaderLocs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__